module.exports = __webpack_public_path__ + "img/sport_ball.fe7cf19e.svg";